import React, { MouseEvent, useEffect, useState } from "react"
import { AppBar, Container, Toolbar, Typography, Box, IconButton, Menu, MenuItem, Button, Tooltip, Grid} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Media from "react-media";
import { useKeyListener } from "../../Hooks/useKeyListener";

const Pages = {
    WhoWeAre: 'Who we are',
    Login: 'Log in',
    SignUp: 'Sign up',
}
export const HorizontalNavbar = () => {
    /* ******************** Hooks ******************** */
    const theme = useTheme();
    const navigate = useNavigate();
    const { currKey } = useKeyListener();
    /* ******************** Variables ******************** */
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const pages = [
        {label: Pages.WhoWeAre, link: "https://www.kazikonekt.com/about"}, 
        {label: Pages.Login, link: "login"}, 
        {label: Pages.SignUp, link: "signup"}
    ]
    /* ******************** Functions ******************** */  
    const handeMenuOpen = (event: MouseEvent<HTMLElement>) =>{
        setAnchorEl(event.currentTarget);
        setMenuOpen(!menuOpen);
    } 
    const handeMenuClose = () =>{
        setAnchorEl(null);
        setMenuOpen(false);
    }
    const handleClick = (page: any) => {
        switch(true){
            case page.label == Pages.WhoWeAre:
                window.location.href = page.link;
                break;
            case currKey === "Shift" && page.label === Pages.Login:
                navigate(`/admin/login`);
                break;
            default:
                navigate(`/${page.link}`);
        }
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */  
    return (
        <Grid item  display={"flex"} flexDirection={"row"} paddingX={4}  xs="auto">
            <Media query={{ maxWidth: 655}}>
                {
                    matches =>
                        matches ?
                        <>
                            <Grid item >
                                <img src="/kazilogo.png" width={178} height={58} />
                            </Grid>
                            <Grid  item display={"flex"} justifyContent={"flex-end"} alignItems={"center"} flex={1}>
                                <IconButton color="primary" onClick={handeMenuOpen}>
                                    <MenuIcon />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={menuOpen}
                                    onClose={handeMenuClose}
                                >
                                    {pages.map((page, idx) => (
                                        <MenuItem key={idx} onClick={() => handleClick(page)}>
                                            <Typography textAlign="center">{page.label}</Typography>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </Grid>
                        </>
                        :
                        <Toolbar disableGutters sx={{display: "flex", flexDirection: "row", width: "100%"}}>
                            <img src="/kazilogo.png" width={178} height={58}/>
                            <Box sx={{ display: "flex", flexDirection:"row", flexGrow: 1, flex: 1, justifyContent: "flex-end"}}>
                                {pages.map((page, idx) => (
                                    <MenuItem key={idx} onClick={() => handleClick(page)}>
                                        <Typography textAlign="center">{page.label}</Typography>
                                    </MenuItem>
                                ))}
                            </Box>
                        </Toolbar>
                }
            </Media>
        </Grid>
    )
}